import React, { useState, useMemo, useEffect, createContext } from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import styles from '../../components/ClickToBuy/index.module.scss';
import { setClickToBuyContext } from '../../components/ClickToBuy/clickContext/clickToBuyContext';
export const ClickToBuyContext = createContext({
    isInClickToBuy: false,
    isAccordionOpen: false,
    setIsAccordionOpen: () => { },
});
function ClickToBuyInner({ analyticsTags, children, breakpointClasses, position }) {
    const [isAccordionOpen, setIsAccordionOpen] = useState(false);
    const clickToBuyContextValue = useMemo(() => ({
        isInClickToBuy: true,
        isAccordionOpen,
        setIsAccordionOpen,
    }), [isAccordionOpen]);
    useEffect(() => {
        if (isAccordionOpen) {
            window.dispatchEvent(new Event('resize'));
        }
    }, [isAccordionOpen]);
    return (React.createElement(ClickToBuyContext.Provider, { value: clickToBuyContextValue },
        React.createElement("div", Object.assign({ id: `trading-asset-${position}`, "data-testid": "click-to-buy-component", className: classNames(styles.tradingCell, breakpointClasses) }, analyticsTags, { onClickCapture: setClickToBuyContext, onKeyDownCapture: setClickToBuyContext }), children)));
}
ClickToBuyInner.propTypes = {
    analyticsTags: propTypes.shape({}),
    breakpointClasses: propTypes.arrayOf(propTypes.string),
    children: propTypes.node,
    position: propTypes.string,
};
export default ClickToBuyInner;
//# sourceMappingURL=ClickToBuyInner.js.map